import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { countryOptions } from '../dropdownOptions';
import { DEFAULT_PRICING_MODEL } from '../pages/constants';
import { Option } from '../pages/types';

/**
 * Deeplink functionality for Product Info pages - allow search, country,
 * pricingModel to persist in search params, and read those fields from search
 * params to initialize. Default values are cleared from search params.
 */
export function useProductInfoUrlState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialSearchText = searchParams.get('search') ?? '';
  const initialCountry =
    countryOptions.find((option) => option.value === searchParams.get('country')?.toUpperCase()) ??
    countryOptions[0];
  const initialPricingModel = searchParams.get('pricingModel') ?? DEFAULT_PRICING_MODEL;

  const [localSearchText, setLocalSearchText] = useState<string>(initialSearchText);
  const [currentSearchText, setCurrentSearchText] = useState<string>(initialSearchText);
  const [selectedCountry, setSelectedCountry] = useState<Option>(initialCountry);
  const [selectedPricingModel, setSelectedPricingModel] = useState<Option>({
    label: initialPricingModel,
    value: initialPricingModel,
  });

  useEffect(() => {
    const params: Record<string, string> = {};
    if (currentSearchText) params.search = currentSearchText;
    if (selectedPricingModel.value !== DEFAULT_PRICING_MODEL)
      params.pricingModel = selectedPricingModel.value;
    if (selectedCountry.value !== countryOptions[0].value) params.country = selectedCountry.value;
    setSearchParams(params, { replace: true });
  }, [currentSearchText, selectedPricingModel, selectedCountry, setSearchParams]);

  return {
    localSearchText,
    setLocalSearchText,
    currentSearchText,
    setCurrentSearchText,
    selectedCountry,
    setSelectedCountry,
    selectedPricingModel,
    setSelectedPricingModel,
  };
}
